import Parse, { Role } from 'parse'

class Card extends Parse.Object {
  
  constructor() {
    super('Card')
  }
  
  get cardHolderName(){
    return this.get('cardHolderName')
  }

  get brand(){
    return this.get('brand')
  }
  
  get expYear(){
    return this.get('expYear')
  }

  get expMonth(){
    return this.get('expMonth')
  }

  get lastFour(){
    return this.get('lastFour')
  }

  dump(){
    console.log(this)
  }

}

export default Card
